import type { ColorResampler } from "./ColorResampler";
import { isColorResampler } from "./ColorResampler";

/**
 * Color resampler with support of Elliptical Weighted Average technique.
 */
export interface EwaColorResampler extends ColorResampler {
  /**
   * Returns weight lookup table used by resampler.
   */
  getWeightLookupTable(): number[];
}

/**
 * Checks if given argument implements EwaColorResampler interface.
 *
 * @param candidate
 */
export function isEwaColorResampler(
  candidate: unknown
): candidate is EwaColorResampler {
  return (
    isColorResampler(candidate) &&
    typeof (candidate as Partial<EwaColorResampler>).getWeightLookupTable ===
      "function"
  );
}
